import type { Navigation, ZudokuConfig } from "zudoku";
import docsNavigationJson from "./navigation.docs.json";
import developerNavigationJson from "./navigation.developer.json";

const docsNavigation = docsNavigationJson as Navigation;
const developerNavigation = developerNavigationJson as Navigation;

const config: ZudokuConfig = {
  site: {
    showPoweredBy: false,
    logo: {
      src: { light: "/aerion-logo-wordmark.svg", dark: "/aerion-logo-wordmark-dark.svg" },
      alt: "Zudoku",
      width: "120px",
    },
    footer: {
      position: "start",
      logo: {
        src: { light: "/aerion-logo-wordmark.svg", dark: "/aerion-logo-wordmark-dark.svg" },
        alt: "Aerion",
        width: "120px",
        href: "https://www.aerion.app",
      },
      columns: [
        {
          title: "Features",
          links: [
            { label: "Planning", href: "https://www.aerion.app/features/skill-based-planning" },
            { label: "Insights", href: "https://www.aerion.app/features/insights" },
            { label: "Skill management", href: "https://www.aerion.app/features/skill-management" },
            { label: "Tracking & approval", href: "https://www.aerion.app/features/time-tracking-approval" },
            { label: "Lifecycle automation", href: "https://www.aerion.app/features/automation" },
          ],
        },
        {
          title: "Product",
          links: [
            { label: "Pricing", href: "https://www.aerion.app/pricing" },
            { label: "Integrations", href: "https://www.aerion.app/integrations" },
            { label: "Changelog", href: "https://www.aerion.app/changelog" },
            { label: "Documentation", href: "https://support.aerion.app" },
            { label: "Download", href: "https://www.aerion.app/download" },
            { label: "Switch", href: "https://www.aerion.app/switch" },
          ],
        },
        {
          title: "Resources",
          links: [
            { label: "Developers", href: "https://docs.aerion.app" },
            { label: "System Status", href: "https://status.aerion.app" },
            { label: "Terms of service", href: "https://www.aerion.app/legal/terms-of-service-en" },
            { label: "Privacy policy", href: "https://www.aerion.app/legal/privacy-policy-en" },
            { label: "Imprint", href: "https://www.aerion.app/legal/imprint" },
          ],
        },
        {
          title: "Company",
          links: [
            { label: "About", href: "https://www.aerion.app/about" },
            { label: "Customers", href: "https://www.aerion.app/customers" },
            { label: "Now", href: "https://www.aerion.app/blog" },
          ],
        },
        {
          title: "Connect",
          links: [
            { label: "Contact us", href: "https://www.aerion.app/contact" },
            { label: "LinkedIn", href: "https://www.linkedin.com/company/aerion-app" },
            { label: "YouTube", href: "https://youtube.com/@aerion-app" },
          ],
        },
      ],
      copyright: `© ${new Date().getFullYear()} CoffeeCup GmbH`,
    },
  },
  metadata: {
    favicon: "/adaptive-favicon.svg",
    title: "%s - Aerion",
    defaultTitle: "Aerion",
  },
  theme: {
    // Zudoku hardcodes `md:max-w-3xl` (~768px) on the footer columns wrapper,
    // which leaves the footer left-aligned and narrow. Drop the cap so the
    // columns stretch across the full content container (max-w-screen-2xl).
    customCss: `
      footer div[style*="--columns"] {
        max-width: none !important;
        width: 100% !important;
      }
      /* Zudoku always renders an empty social-icons div in the bottom row; with
         justify-between that empties slot centers the copyright. Hide it when
         no social entries are configured. */
      footer .border-t > .gap-2:empty {
        display: none;
      }
    `,
  },
  search: {
    type: "pagefind",
  },
  docs: {
    defaultOptions: {
      showLastModified: false,
    },
  },
  navigation: [
    {
      type: "category",
      label: "Docs",
      items: docsNavigation,
    },
    {
      type: "category",
      label: "Developer",
      items: developerNavigation,
    },
    {
      type: "link",
      to: "/api",
      label: "API Reference",
    },
  ],
  redirects: [{ from: "/", to: "/guides/start-guide" }],
  // redirects: [{ from: "/", to: "/developer/overview" }],

  apis: [
    {
      type: "file",
      input: "./apis/swagger.json",
      path: "/api",
      // @ts-expect-error disableSecurity is honored at runtime but missing from ApiOptionsSchema
      options: { disableSecurity: false, },
    },
    // {
    //   type: "url",
    //   input: "https://api.aerion.app/swagger/json",
    //   path: "/api2",
    //   options: {
    //     showInfoPage: true,
    //   }
    // }
  ],
};

export default config;
